import { useOutletContext } from "react-router-dom";
import { useNavigate, useParams } from "react-router";
import { useRescheduleSession } from "@src/queries/scheduler";
import { useState } from "react";
import { usePsychologistsConsultQuery } from "@src/queries/experts";
import { useTranslation } from "react-i18next";
import TimeSlotPicker from "./TimeSlot/TimeSlotPicker";

const RescheduleSessionFlow = () => {
  const { showSnackbarMessage } = useOutletContext();
  const { consultId } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [reasonReschedule, setReasonReschedule] = useState("");

  const { data: consult } = usePsychologistsConsultQuery(consultId);
  const { mutateAsync: rescheduleSession } = useRescheduleSession();

  const handleBookSessionClick = (selectedTime) => {
    const { startTime } = selectedTime;
    const { endTime } = selectedTime;
    const { timezone } = selectedTime;
    rescheduleSession({
      consultId: consult.id,
      startTime,
      endTime,
      reasonReschedule,
      timezone,
    })
      .then((response) => {
        showSnackbarMessage(t("Reschedule.Result.Success"));
        navigate(-1);
        return response;
      })
      .catch(() => {
        showSnackbarMessage(t("Common.GenericErrorMessage"));
      });
  };

  return (
    consult && (
      <TimeSlotPicker
        onBookSession={handleBookSessionClick}
        sessionType={consult.consultType}
        language={consult.consultLanguage}
        consult={consult}
        setReasonReschedule={setReasonReschedule}
      />
    )
  );
};

export default RescheduleSessionFlow;
